import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import { FormControl } from "baseui/form-control";
import { useSetObjectValue } from '../../../../hooks/useSetObjectValue';
import { IP_Floor } from './types';
import { useIntl, FormattedMessage } from 'react-intl';
import { Notification } from 'baseui/notification'
import { Button } from 'baseui/button';
import { useState } from 'react';


export const ConfigurationPanel = (props: IP_Floor) => {
    const intl = useIntl();

    const [state, setState] = useState({ hasChanges: false, floorNumber: props.floorNumber })
    const [floorNumber, setFloorNumber, setFloorNumberResult] = useSetObjectValue(props.id, props.resourceGroupId, "floorNumber", props.floorNumber);
    const [initialzed, setInitialzed, setInitialzedResult] = useSetObjectValue(props.id, props.resourceGroupId, "initialized", props.initialized);

    const onFloorNumberChanged = (e: any) => {
        setState(prevState => ({
            ...prevState,
            floorNumber: parseFloat(e.target.value),
            hasChanges: true
        }))
    }

    function onApplyChanges() {
        setFloorNumber(state.floorNumber);
        setInitialzed(true);
        setState(prevState => ({
            ...prevState,
            hasChanges: false
        }))
    }

    return (
        <>
            <Block gridRowGap='20px' display='flex' flexDirection='column' >
                
                {!initialzed && <Notification overrides={{ Body: { style: { width: 'auto' } }, }} kind='warning' closeable ><FormattedMessage id="P_Floor.NotInitialized" defaultMessage="Please enter the floor configuration in order to use its full functionality" /></Notification>}
                <FormControl
                    label={() => intl.formatMessage({ id: "P_Floor.FloorNumberInput", defaultMessage: "Floor Number" })}
                    caption={() => intl.formatMessage({ id: "P_Floor.FloorNumberInputDescr", defaultMessage: "Enter the floor number (0 = Ground Floor, 1 = First Floor etc.). This is used to correctly order floors etc." })}
                >
                    <Input
                        value={state.floorNumber}
                        onChange={onFloorNumberChanged}
                        type='number'
                    />
                </FormControl>
                <Button size='compact' isLoading={setFloorNumberResult.isLoading} disabled={!state.hasChanges} onClick={onApplyChanges}><FormattedMessage id="applyChanges" defaultMessage="Apply changes" /></Button>

            </Block>
        </>
    )
}
